export const DASHBOARD_GET_ALL = "/dashboard";
